<div
	class="toast-stack pointer-events-none fixed inset-x-0 z-1100 flex flex-col items-start gap-2 overflow-hidden px-4"
	aria-live="polite"
	[class.top-14]="position() === 'top'"
	[class.bottom-20]="position() === 'bottom'">
	@for (toast of toastService.toasts(); track toast.id) {
		<ui-toast
			class="pointer-events-auto"
			[message]="messageWithCount(toast)"
			[variant]="toast.variant"
			[structure]="toast.structure"
			[size]="toast.size"
			[actionLabel]="toast.actionLabel"
			(actionClicked)="onAction(toast)" />
	}
</div>
